// extracted by mini-css-extract-plugin
export default {"notification":"FeatureDisabled_notification__YB8hS","notificationText":"FeatureDisabled_notificationText__4qsBe"};